/**
 * Gestione Mense Backend Authentication API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { ExceptionResponseDTO } from '../model/exceptionResponseDTO';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class PagoPAWebhookService {

    protected basePath = 'https://demo-api.mensapp.it/gestione-mense';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Webhook notifica pagamento Maggioli
     * Endpoint pubblico chiamato da Maggioli al completamento di un pagamento PagoPA. Aggiorna lo stato della ricarica a PAGATA e ricalcola il portafogli dello studente.
     * @param queryParams 
     * @param body 
     * @param iuv 
     * @param slugComune 
     * @param annoDiRiferimento 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public notificaPagamento(queryParams: { [key: string]: string; }, body?: string, iuv?: string, slugComune?: string, annoDiRiferimento?: string, observe?: 'body', reportProgress?: boolean): Observable<{ [key: string]: string; }>;
    public notificaPagamento(queryParams: { [key: string]: string; }, body?: string, iuv?: string, slugComune?: string, annoDiRiferimento?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<{ [key: string]: string; }>>;
    public notificaPagamento(queryParams: { [key: string]: string; }, body?: string, iuv?: string, slugComune?: string, annoDiRiferimento?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<{ [key: string]: string; }>>;
    public notificaPagamento(queryParams: { [key: string]: string; }, body?: string, iuv?: string, slugComune?: string, annoDiRiferimento?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (queryParams === null || queryParams === undefined) {
            throw new Error('Required parameter queryParams was null or undefined when calling notificaPagamento.');
        }





        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (iuv !== undefined && iuv !== null) {
            queryParameters = queryParameters.set('iuv', <any>iuv);
        }
        if (slugComune !== undefined && slugComune !== null) {
            queryParameters = queryParameters.set('slugComune', <any>slugComune);
        }
        if (annoDiRiferimento !== undefined && annoDiRiferimento !== null) {
            queryParameters = queryParameters.set('annoDiRiferimento', <any>annoDiRiferimento);
        }
        if (queryParams !== undefined && queryParams !== null) {
            queryParameters = queryParameters.set('queryParams', <any>queryParams);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<{ [key: string]: string; }>('post',`${this.basePath}/api/v1/webhooks/pagopa/maggioli/notifica`,
            {
                body: body,
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
